import styled from "styled-components";

export const SettingsContent = styled.div`
	margin-left: 175px;
	padding: 24px;
`;
